// Page Elements
const resultsContainer = document.querySelector(".results-container");
const stockistsList = document.querySelector(".stockists-list");
const listingsList = document.querySelector(".listings-list");
const stockistFilterItems = Array.from(document.querySelectorAll(".filter-button"));
const filterContainer = document.querySelector(".filter-container");
const locationItems = Array.from(document.querySelectorAll(".location"));
const stockistTypeFilters = document.querySelectorAll(".stockist-filter");

// Filter by stockist type
stockistTypeFilters.forEach((filterItem) => {
  filterItem.onclick = () => filterByType(filterItem);
});

// Filter by location
stockistFilterItems.forEach((filterItem) => {
  filterItem.onclick = () => filterCategories(filterItem);
});

const filterByType = (target) => {
  const selectedFilter = target.getAttribute("data-type");
  stockistTypeFilters.forEach((filterItem) => {
    filterItem.classList.remove("active");
  });
  target.classList.add("active");

  if (selectedFilter === "all") {
    resultsContainer.classList.add("active");
    listingsList.classList.remove("hidden");
    if (stockistsList) {
      stockistsList.classList.remove("hidden");
    }
  } else if (selectedFilter === "retailers") {
    resultsContainer.classList.remove("active");
    listingsList.classList.add("hidden");
    if (stockistsList) {
      stockistsList.classList.remove("hidden");
    }
  } else {
    resultsContainer.classList.remove("active");
    listingsList.classList.remove("hidden");
    if (stockistsList) {
      stockistsList.classList.add("hidden");
    }
  }

  if (target.getAttribute("data-hide-filters") == "true") {
    filterContainer.classList.add("hidden");
  } else {
    filterContainer.classList.remove("hidden");
  }
};

const filterCategories = function (target) {
  const selectedFilter = target.getAttribute("data-location");
  if (stockistsList) {
    stockistsList.setAttribute("data-filtered", selectedFilter);
  };
  listingsList.setAttribute("data-filtered", selectedFilter);
  stockistFilterItems.forEach((filterItem) => {
    filterItem.classList.remove("active");
  });
  locationItems.forEach((filterItem) => {
    filterItem.classList.remove("active");
  });
  target.classList.add("active");

  document.querySelectorAll(`.location[data-location-${selectedFilter}="true"]`).forEach((filterItem) => {
    filterItem.classList.add("active");
  });
};

// Search for stockists
mapboxgl.accessToken = "pk.eyJ1IjoiYmVsbGFjb2FscGl0bnQiLCJhIjoiY20wZjVzbnkzMHBidTJucXY2MWVxcHZqeiJ9.3y6SN3r326Xj5VTpKFFYaw";
let searchedCoords = [];

document.getElementById("address-autofill").addEventListener("retrieve", function (event) {
  searchedCoords = event.detail.features[0].geometry.coordinates;
  document.getElementById("search-form").dispatchEvent(new Event("submit"));
  document.getElementById("address").value = event.detail.features[0].properties.full_address;
});

const locations = locationItems.map((location) => {
  const coords = location.getAttribute("data-coords")?.split(", ");
  return {
    title: location.getAttribute("data-title"),
    lat: coords ? parseFloat(coords[0]) : null,
    lng: coords ? parseFloat(coords[1]) : null,
  };
});

const calculateDistance = (lat1, lng1, lat2, lng2) => {
  const toRad = (value) => (value * Math.PI) / 180;

  const R = 3958.8; // Radius of the Earth in miles
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c; // Distance in miles
};

const displayResults = (locations) => {
  const resultsContainer = document.getElementById("results");
  resultsContainer.innerHTML = "";

  if (locations.length > 0) {
    locationItems.forEach((location) => {
      if (locations.find((l) => l.title === location.getAttribute("data-title"))) {
        location.style.display = "block";
      } else {
        location.style.display = "none";
      }
    });
  } else {
    resultsContainer.textContent = "No nearby locations found.";
    locationItems.forEach((location) => {
      location.style.display = "block";
    });
  }
};

const searchStockists = (event) => {
  event.preventDefault();
  const address = document.getElementById("address").value;
  if (!address) {
    return displayResults(locations);
  }
  const userLat = searchedCoords[1];
  const userLng = searchedCoords[0];

  const locationsWithDistance = locations.map((location) => {
    const distance = calculateDistance(userLat, userLng, location.lat, location.lng);
    return {
      ...location,
      distance,
    };
  });

  const sortedLocations = locationsWithDistance.filter((l) => !isNaN(l.distance)).sort((a, b) => a.distance - b.distance);
  const topTen = sortedLocations.slice(0, 10);
  displayResults(topTen);
};
